<div class="container options-calculation-container">
  <div class="float-left bg-white card-background-fullwidth">
    <form [formGroup]="quoteForm" autocomplete="off" role="form" class="fieldHeight">
      <div class="row">
        <app-content-top-nav [parentElement]="el" [parentFormToValidate]="quoteForm" [visibleBackNav]='true'
          [enableBackNav]='!editMode' (onBackClickHandler)="OnBackClick()">
        </app-content-top-nav>
      </div>
      <div class="row">
        <div class="col-md-12 clear-all title-inner-container">
          <h1 [innerHTML]="header" id="yourPensionAnnuityOptions-header" class="custom-header-h2 responsive-text-8">
          </h1>
        </div>
      </div>
      <div class="content-container">
        <div class="row">
          <div class="col-md-12">
            <p role="heading" aria-level="2" class="content-top margin-top-0"
              id="yourPensionAnnuityOptions-introduction">
              {{contentData.introduction}}</p>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 inner-content bg-lightblue align-center mar-lr-0">
            <p class="inner-content-data" id="defined-benefit">{{contentData.notificationBanner}}</p>
          </div>
        </div>
        <div class="row data-container">
          <div class="content-section">
            <div class="width-47" *ngIf="selectedProduct && (selectedProduct.productCode !== 'G')">
              <div class="row mt-5">
                <app-question [childId]="'currentDate'" [questionConfig]="currentDateConfig" [parent]="quoteForm"
                  [controlName]="'currentDate'" (valueChange)='toggleCurrentDate($event)'
                  (dateInputHandler)="dateChange($event)" [controllerData]="userInputDetail.startDate"
                  [isdateReq]="true" [commencementDateConfigObj]="commencementDateConfig"
                  [startDateAgeRangeConfigObj]="startDateAgeRangeConfig"
                  (onDisplayMobileTooltipEmitter)="displayTooltipMessage(currentDateConfig)">
                </app-question>
              </div>
              <div class="row">
                <div [id]="'current-startDate-error'" class="form-validation-error" *ngIf="currentAndStartDateError">
                  <i class="icon icon-error" aria-hidden="true"></i>
                  <p>{{contentData.currentAndStartDateErrorValidationMsg}}</p>
                </div>
              </div>
              <ng-container
                *ngIf="selectedProduct && (selectedProduct.productCode === 'H' || selectedProduct.productCode === 'G')">
                <div class="width-100">
                  <div class="questions-container col-md-2 clear-all width-6"></div>
                  <div class="row mt-5">
                    <app-question [childId]="'increasedIncomePlayground'" (valueChange)='toggleSlider($event,"income")'
                      [questionConfig]="userInputDetail.radioButtonincraeseincomeConfig" [parent]="quoteForm"
                      [controlName]="'increasedincome'"
                      (onDisplayMobileTooltipEmitter)="displayTooltipMessage(userInputDetail.radioButtonincraeseincomeConfig)">
                    </app-question>
                  </div>
                  <div *ngIf="showIncomeSlider" class="row">
                    <app-simple-slider [sliderId]="'increasedSlider'"
                      [sliderConfig]="userInputDetail.sliderincreaseIncomeConfig" [parent]="quoteForm"
                      [controlName]="'increasedincomeslider'"
                      (onDisplayMobileTooltipEmitter)="displayTooltipMessage(userInputDetail.sliderincreaseIncomeConfig)"></app-simple-slider>
                  </div>
                </div>
              </ng-container>
            </div>
            <div class="width-6"></div>
            <div class="width-47" *ngIf="selectedProduct && (selectedProduct.productCode === 'H')">
              <div class="row mt-5">
                <app-simple-slider [sliderId]="'termSlider'" [sliderConfig]="userInputDetail.sliderTermConfig"
                  [parent]="quoteForm" [controlName]="'termplan'" (onScrollEndHandler)="changeScrollParams($event)"
                  (onDisplayMobileTooltipEmitter)="displayTooltipMessage(userInputDetail.sliderTermConfig)">
                </app-simple-slider>
              </div>
              <div class="row cl03" [ngClass]="{'disable-slider':disableMonthSlider}">
                <!-- <div class="questions-container" > -->
                <app-simple-slider [sliderId]="'termmonthSlider'"
                  [sliderConfig]="userInputDetail.sliderMonthlyTermConfig" [parent]="quoteForm"
                  [controlName]="'termmonth'" [disable]="disableMonthSlider"
                  (onScrollEndHandler)="changeScrollParams($event)"
                  (onDisplayMobileTooltipEmitter)="displayTooltipMessage(userInputDetail.sliderMonthlyTermConfig)">
                </app-simple-slider>
                <!-- </div> -->
              </div>
              <div class="row">
                <div [id]="'ftrptermmonth-error'" class="form-validation-error" *ngIf="sliderErrorVisible">
                  <i class="icon icon-error" aria-hidden="true"></i>
                  <p>{{userInputDetail.sliderMonthlyTermConfig.validationMsg}}</p>
                </div>
              </div>
            </div>
            <div class="width-47" *ngIf="selectedProduct && (selectedProduct.productCode === 'C')">
              <div class="row mt-5">
                <app-question [childId]="'frequencyPlayground'" [questionConfig]="frequencyConfig" [parent]="quoteForm"
                  [productCode]="'C'" [controlName]="'frequency'"
                  (onDisplayMobileTooltipEmitter)="displayTooltipMessage(frequencyConfig)">
                </app-question>
              </div>
            </div>
          </div>
          <!-- 1st oart done -->
          <ng-container *ngIf="selectedProduct && (selectedProduct.productCode === 'H')">
            <div class="content-section">
              <div class="width-47">
                <div class="row mt-5">
                  <app-question [childId]="'incomematurity'"
                    [questionConfig]="userInputDetail.radioButtonincomeMaturityConfig" [parent]="quoteForm"
                    [controlName]="'incomematurity'" (valueChange)='toggleMaturity($event)'
                    (onDisplayMobileTooltipEmitter)="displayTooltipMessage(userInputDetail.radioButtonincomeMaturityConfig)">
                  </app-question>
                </div>
                <div class="row">
                  <app-currency *ngIf="source" [parent]="quoteForm" [controllerData]="userInputDetail.fundValueConfig"
                    [controlName]="'fundValue'" [componentName]="'yourOptions'" [source]="source"
                    (currencyChangeEventEmitter)="currencyChangeHandler($event)"
                    (onDisplayMobileTooltipEmitter)="displayTooltipMessage(userInputDetail.fundValueConfig)"></app-currency>
                </div>
                <div [id]="controlName+'-ACEError'" class="row form-validation-error" *ngIf="ACEErrorString">
                  <i class="icon icon-error" aria-hidden="true"></i>
                  <p>{{ACEErrorString}}</p>
                </div>
              </div>
              <div class="width-6"></div>
              <div class="width-47">
                <div class="row mt-5">
                  <app-question [childId]="'frequencyPlayground'" [questionConfig]="frequencyConfig"
                    [parent]="quoteForm" [productCode]="'H'" [controlName]="'frequency'"
                    (onDisplayMobileTooltipEmitter)="displayTooltipMessage(frequencyConfig)">
                  </app-question>
                </div>
              </div>
            </div>
            <div class="content-section">
              <div class="width-47">
                <app-question [childId]="'advance'" [questionConfig]="userInputDetail.radioButtonAdvanceFTRPConfig"
                  [parent]="quoteForm" [controlName]="'advance'"
                  (onDisplayMobileTooltipEmitter)="displayTooltipMessage(userInputDetail.radioButtonAdvanceFTRPConfig)">
                </app-question>
              </div>
              <div class="width-6"></div>
              <div class="width-47">
                <div class="nested-content-section">
                  <div class="row">
                    <app-question [childId]="'taxfreeCashPlayground'" (valueChange)='toggleSlider($event,"taxfree")'
                      [questionConfig]="userInputDetail.radioButtontaxfreeCashConfig" [parent]="quoteForm"
                      [controlName]="'taxfreeRadioButton'"
                      (onDisplayMobileTooltipEmitter)="displayTooltipMessage(userInputDetail.radioButtontaxfreeCashConfig)">
                    </app-question>
                  </div>
                  <div *ngIf="showTaxfreeSlider" class="row">
                    <app-simple-slider [sliderId]="'taxfreeSlider'"
                      (calculatedValueClickHandler)="oncalculatedValue($event, 'primary')"
                      [sliderConfig]="userInputDetail.sliderTaxfreeLumpsumConfig" [parent]="quoteForm"
                      [controlName]="'taxfreelumpsum'" (onScrollEndHandler)="changeScrollParams($event)"
                      [fundAmount]="(this.pensionArray && this.pensionArray.length > 0) ? this.pensionArray[0].fundValue : 0"></app-simple-slider>
                  </div>
                  <div *ngIf="showTaxfreeInput" class="row">
                    <app-currency *ngIf="source" [parent]="quoteForm"
                      [controllerData]="userInputDetail.taxfreeValueConfig" [controlName]="'fundValueTaxfree'"
                      [componentName]="'yourOptions'" [source]="source"
                      (currencyChangeEventEmitter)="taxfreeChangeHandler($event,'first')"></app-currency>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <!-- 2nd part done -->
          <ng-container *ngIf="selectedProduct && selectedProduct.productCode === 'C'">
            <div class="content-section">
              <div class="width-47">
                <div class="row mt-5">
                  <app-question [childId]="'advancePlayground'"
                    [questionConfig]="userInputDetail.radioButtonAdvanceConfig" [parent]="quoteForm"
                    [controlName]="'advance'"
                    (onDisplayMobileTooltipEmitter)="displayTooltipMessage(userInputDetail.radioButtonAdvanceConfig)">
                  </app-question>
                </div>
              </div>
              <div class="width-6"></div>
              <div class="width-47">
                <div class="row mt-5">
                  <app-question [childId]="'increasedIncomePlayground'" (valueChange)='toggleSlider($event,"income")'
                    [questionConfig]="userInputDetail.radioButtonincraeseincomeConfig" [parent]="quoteForm"
                    [controlName]="'increasedincome'"
                    (onDisplayMobileTooltipEmitter)="displayTooltipMessage(userInputDetail.radioButtonincraeseincomeConfig)">
                  </app-question>
                </div>
                <div *ngIf="showIncomeSlider" class="row">
                  <app-simple-slider [sliderId]="'increasedSlider'"
                    [sliderConfig]="userInputDetail.sliderincreaseIncomeConfig" [parent]="quoteForm"
                    [controlName]="'increasedincomeslider'"
                    (onDisplayMobileTooltipEmitter)="displayTooltipMessage(userInputDetail.sliderincreaseIncomeConfig)"></app-simple-slider>
                </div>
              </div>
            </div>
            <div class="content-section">
              <div class="width-47"
                *ngIf="!(source == 'external' && selectedProduct && selectedProduct['productCode'] == 'C')">
                <div class="row mt-5">
                  <app-question [childId]="'taxfreeCashPlayground'" (valueChange)='toggleSlider($event,"taxfree")'
                    [questionConfig]="userInputDetail.radioButtontaxfreeCashConfig" [parent]="quoteForm"
                    [controlName]="'taxfreeRadioButton'"
                    (onDisplayMobileTooltipEmitter)="displayTooltipMessage(userInputDetail.radioButtontaxfreeCashConfig)">
                  </app-question>
                </div>
                <div *ngIf="showTaxfreeSlider" class="row">
                  <app-simple-slider [sliderId]="'taxfreeSlider'"
                    (calculatedValueClickHandler)="oncalculatedValue($event, 'primary')"
                    [sliderConfig]="userInputDetail.sliderTaxfreeLumpsumConfig" [parent]="quoteForm"
                    [controlName]="'taxfreelumpsum'" (onScrollEndHandler)="changeScrollParams($event)"
                    [fundAmount]="(this.pensionArray && this.pensionArray.length > 0) ? this.pensionArray[0].fundValue : 0"
                    (onDisplayMobileTooltipEmitter)="displayTooltipMessage(userInputDetail.sliderTaxfreeLumpsumConfig)"></app-simple-slider>
                </div>
                <div *ngIf="showTaxfreeInput" class="row">
                  <app-currency *ngIf="source" [parent]="quoteForm"
                    [controllerData]="userInputDetail.taxfreeValueConfig" [controlName]="'fundValueTaxfree'"
                    [componentName]="'yourOptions'" [source]="source"
                    (currencyChangeEventEmitter)="taxfreeChangeHandler($event,'first')"
                    (onDisplayMobileTooltipEmitter)="displayTooltipMessage(userInputDetail.taxfreeValueConfig)"></app-currency>
                </div>
              </div>
              <div class="width-6"
                *ngIf="!(source == 'external' && selectedProduct && selectedProduct['productCode'] == 'C')"></div>
              <div class="width-47"
                *ngIf="(multipleTaxfree || (source == 'external' && selectedProduct && selectedProduct['productCode'] == 'C'))">
                <div class="questions-container clear-all">
                  <div class="row mt-5">
                    <app-question [childId]="'taxfreeCashPlaygroundSecond'"
                      (valueChange)='toggleSlider($event,"taxfreeSecond")'
                      [questionConfig]="userInputDetail.radioButtontaxfreeCashOthersConfig" [parent]="quoteForm"
                      [controlName]="'taxfreeRadioButtonSecondary'"
                      (onDisplayMobileTooltipEmitter)="displayTooltipMessage(userInputDetail.radioButtontaxfreeCashOthersConfig)">
                    </app-question>
                  </div>
                  <div class="row mt-5"
                    *ngIf="showSecondTaxfreeSlider && !(source == 'external' && selectedProduct && selectedProduct['productCode'] == 'C')">
                    <app-simple-slider [sliderId]="'taxfreeSlider'"
                      (calculatedValueClickHandler)="oncalculatedValue($event, 'secondary')"
                      [sliderConfig]="userInputDetail.sliderTaxfreeLumpsumConfigSecondary" [parent]="quoteForm"
                      [controlName]="'taxfreelumpsumSecondary'" (onScrollEndHandler)="changeScrollParams($event)"
                      [fundAmount]="(this.pensionArray && this.pensionArray.length > 1) ? this.pensionArray[1].fundValue : 0"></app-simple-slider>
                  </div>
                  <div class="row mt-5"
                    *ngIf="showSecondTaxfreeSlider && (source == 'external' && selectedProduct && selectedProduct['productCode'] == 'C')">
                    <app-simple-slider [sliderId]="'taxfreeSlider'"
                      (calculatedValueClickHandler)="oncalculatedValue($event, 'secondary')"
                      [sliderConfig]="userInputDetail.sliderTaxfreeLumpsumConfigSecondary" [parent]="quoteForm"
                      [controlName]="'taxfreelumpsumSecondary'" (onScrollEndHandler)="changeScrollParams($event)"
                      [fundAmount]="(this.pensionArray && this.pensionArray.length > 0) ? this.pensionArray[0].fundValue : 0"
                      (onDisplayMobileTooltipEmitter)="displayTooltipMessage(userInputDetail.sliderTaxfreeLumpsumConfigSecondary)"></app-simple-slider>
                  </div>
                  <div *ngIf="showSecondTaxfreeInput" class="row">
                    <!-- mt-5 -->
                    <app-currency *ngIf="source" [parent]="quoteForm"
                      [controllerData]="userInputDetail.secondaryTaxfreeValueConfig"
                      [controlName]="'fundValueTaxfreeSecondary'" [componentName]="'yourOptions'" [source]="source"
                      (currencyChangeEventEmitter)="taxfreeChangeHandler($event,'second')"
                      (onDisplayMobileTooltipEmitter)="displayTooltipMessage(userInputDetail.secondaryTaxfreeValueConfig)"></app-currency>
                  </div>
                </div>
              </div>
              <!-- {{666677}} {{multipleTaxfree}} -->
              <div *ngIf="!multipleTaxfree" class="width-47">
                <div class="col-md-12 clear-all">
                  <!-- Modifed Question -->
                </div>
              </div>
            </div>
            <div class="content-section" *ngIf="multipleTaxfree">
              <div class="width-47">
                <div class="row mt-5">
                  <!-- Added the Modified VP Slider here -->
                  <app-question [childId]="'valueProtectionPlayground'" (valueChange)='toggleValueProtection($event)'
                    [questionConfig]="userInputDetail.radioButtonvalueProtectionConfig" [parent]="quoteForm"
                    [controlName]="'valueprotection'"
                    (onDisplayMobileTooltipEmitter)="displayTooltipMessage(userInputDetail.radioButtonvalueProtectionConfig)">
                  </app-question>
                </div>
              </div>
              <div class="width-6"></div>
              <div class="width-47" aria-hidden="disableInvestmentSlider ? true : false">
                <div class="row mt-5">
                  <app-simple-slider [sliderId]="'vpSlider'" [sliderConfig]="userInputDetail.slidervpConfig"
                    [parent]="quoteForm" [controlName]="'vpslider'" (onScrollEndHandler)="changeScrollParams($event)"
                    (goToDependantsPageSSHandler)="goToDependatsPageYOC()" [disable]='disableInvestmentSlider'>
                    <div class="textUnderSlider" *ngIf="vpWarningFlag">
                      <p class="inner-content-data">{{contentData.valueProtectionWarningMessage}}</p>
                    </div>
                  </app-simple-slider>
                </div>
              </div>
            </div>
            <div class="content-section" *ngIf="!multipleTaxfree">
              <div class="width-47">
                <div class="row mt-5">
                  <app-question [childId]="'valueProtectionPlayground'" (valueChange)='toggleValueProtection($event)'
                    [questionConfig]="userInputDetail.radioButtonvalueProtectionConfig" [parent]="quoteForm"
                    [controlName]="'valueprotection'" [isButtonAlignToBeChanged]=true
                    (onDisplayMobileTooltipEmitter)="displayTooltipMessage(userInputDetail.radioButtonvalueProtectionConfig)">
                  </app-question>
                </div>
                <div *ngIf="showWarningValueProtection" class="row inner-content-new">
                  <div>{{contentData.noIncomeWarningMessage}}</div>
                </div>
              </div>
              <div class="width-6"></div>
              <div class="width-47" aria-hidden="disableInvestmentSlider ? true : false">
                <div class="row mt-5">
                  <app-simple-slider [sliderId]="'vpSlider'" [sliderConfig]="userInputDetail.slidervpConfig"
                    [parent]="quoteForm" [controlName]="'vpslider'" (onScrollEndHandler)="changeScrollParams($event)"
                    (goToDependantsPageSSHandler)="goToDependatsPageYOC()" [disable]='disableInvestmentSlider'
                    (onDisplayMobileTooltipEmitter)="displayTooltipMessage(userInputDetail.slidervpConfig)">
                    <div class="textUnderSlider mt-35" *ngIf="vpWarningFlag">
                      <p class="inner-content-data">{{contentData.valueProtectionWarningMessage}}</p>
                    </div>
                  </app-simple-slider>
                </div>
              </div>
            </div>
            <div class="content-section" *ngIf="multipleTaxfree">
              <div class="row  width-47" aria-hidden="disableIncomeSlider ? true : false">
                <app-simple-slider [sliderId]="'periodSlider'"
                  [sliderConfig]="userInputDetail.sliderperiodOfIncomeConfig" [parent]="quoteForm"
                  [controlName]="'periodofincome'" [disable]='disableIncomeSlider'
                  (goToDependantsPageSSHandler)="goToDependatsPageYOC()"
                  (onScrollEndHandler)="changeScrollParams($event)">
                  <div *ngIf="showWarningforGuaranteedIncome" class="textUnderSlider">
                    <p class="inner-content-data">You are opting out of this benefit. This means that your Estate would
                      not
                      receive an income after your death.</p>
                  </div>
                </app-simple-slider>
              </div>
              <!-- width-47 manually added -->
              <div class="width-6"></div>
              <div class="row width-47" aria-hidden="disableDependantIncomeSlider ? true : false">
                <!-- mt-5 -->
                <app-simple-slider [sliderId]="'percentageSlider'"
                  [sliderConfig]="userInputDetail.sliderIncomePercentageConfig" [parent]="quoteForm"
                  [controlName]="'incomepercentage'" [disable]='disableDependantIncomeSlider'
                  (goToDependantsPageSSHandler)="goToDependatsPageYOC()"
                  (onScrollEndHandler)="changeScrollParams($event)" [enableTooltip]="enableDependantTooltip"
                  (onDisplayMobileTooltipEmitter)="displayTooltipMessage(userInputDetail.sliderIncomePercentageConfig)">
                  <div *ngIf="showWarningforDependentIncome" class="textUnderSlider">
                    <p class="inner-content-data">You are opting out of this benefit. This means that your dependant
                      would not
                      receive an income after your death.</p>
                  </div>
                </app-simple-slider>
              </div>
            </div>
            <div class="content-section" *ngIf="!multipleTaxfree">
              <div class="width-47" aria-hidden="disableIncomeSlider ? true : false">
                <div class="row mt-5">
                  <app-simple-slider [sliderId]="'periodSlider'"
                    [sliderConfig]="userInputDetail.sliderperiodOfIncomeConfig" [parent]="quoteForm"
                    [controlName]="'periodofincome'" [disable]='disableIncomeSlider'
                    (goToDependantsPageSSHandler)="goToDependatsPageYOC()"
                    (onScrollEndHandler)="changeScrollParams($event)"
                    (onDisplayMobileTooltipEmitter)="displayTooltipMessage(userInputDetail.sliderperiodOfIncomeConfig)">
                    <div *ngIf="showWarningforGuaranteedIncome" class="textUnderSlider">
                      <p class="inner-content-data">You are opting out of this benefit. This means that your Estate
                        would not
                        receive an income after your death.</p>
                    </div>
                  </app-simple-slider>
                </div>
              </div>
              <div class="width-6"></div>
              <div class="width-47" aria-hidden="disableIncomeSlider ? true : false">
                <div class="row mt-5">
                  <app-simple-slider [sliderId]="'percentageSlider'"
                    [sliderConfig]="userInputDetail.sliderIncomePercentageConfig" [parent]="quoteForm"
                    [controlName]="'incomepercentage'" [disable]='disableDependantIncomeSlider'
                    [enableTooltip]="enableDependantTooltip" (goToDependantsPageSSHandler)="goToDependatsPageYOC()"
                    (onScrollEndHandler)="changeScrollParams($event)"
                    (onDisplayMobileTooltipEmitter)="displayTooltipMessage(userInputDetail.sliderIncomePercentageConfig)">
                    <div *ngIf="showWarningforDependentIncome" class="textUnderSlider">
                      <p class="inner-content-data">You are opting out of this benefit. This means that your dependant
                        would not
                        receive an income after your death.</p>
                    </div>
                  </app-simple-slider>
                </div>
              </div>
            </div>
            <div class="row add-quote-button button-center-align-container" *ngIf="multipleTaxfree">
              <button *ngIf="loadingFlag" class="btn btn-primary btn-loading mbr-40-index float-right" type="button">
                <span class="btn-text">Primary button</span>
                <div class="spinner spinner-white">
                  <div class="spinner-ring" aria-hidden="true"></div>
                  <span class="access">Loading...</span>
                </div>
              </button>

              <div class="button-container">
                <app-content-bottom-nav *ngIf="!loadingFlag" (onNextHandler)="gotoNextPage()"
                  [userInputDetail]="userInputDetail['buttonAddCalculationConfig']" [buttonType]="'primarybutton'">
                </app-content-bottom-nav>
              </div>
            </div>
            <!-- {{multipleTaxfree}}
            <div class="row add-quote-button button-center-align-container" *ngIf="!multipleTaxfree">
              <button *ngIf="loadingFlag" class="btn btn-primary btn-loading mbr-40-index float-right" type="button">
                <span class="btn-text">Primary button</span>
                <div class="spinner spinner-white">
                  <div class="spinner-ring" aria-hidden="true"></div>
                  <span class="access">Loading...</span>
                </div>
              </button>

              <div class="button-container">
                <app-content-bottom-nav *ngIf="!loadingFlag" (onNextHandler)="gotoNextPage()"
                  [userInputDetail]="userInputDetail['buttonAddCalculationConfig']" [buttonType]="'primarybutton'">
                </app-content-bottom-nav>
              </div>
            </div> -->
          </ng-container>
          <!-- 3rd part done -->
          <div class="width-100" *ngIf="selectedProduct && (selectedProduct.productCode === 'G')">
            <div class="row mt-5">
              <app-cashout-retirement-plan *ngIf="source" [quoteForm]="quoteForm" [userInputDetail]="userInputDetail"
                [sliderErrorVisible]="sliderErrorVisible"
                (calculatedValueClickHandler)="oncalculatedValue($event, 'primary')"
                [showTaxfreeSlider]="showTaxfreeSlider" [showIncomeSlider]="showIncomeSlider"
                [showTaxfreeInput]="showTaxfreeInput" [pensionArray]="pensionArray" [taxfreePerc]="taxfreePerc"
                [taxFreeFund]="taxFreeFund" (currencyChangeEventEmitter)="taxfreeChangeHandler($event,'first')"
                (valueChange)='toggleSlider($event,"taxfree")' (valueChangeIncomeSlider)='toggleSlider($event,"income")'
                [source]="source" (dateInputHandler)="dateChange($event)" (dateValueChange)='toggleCurrentDate($event)'
                [contentData]="contentData"
                (corpTooltipHandler)="displayCorpTooltipMessage($event)"></app-cashout-retirement-plan>
            </div>
          </div>
          <!-- 4th part done -->
          <ng-container
            *ngIf="selectedProduct && (selectedProduct.productCode === 'H' || selectedProduct.productCode === 'G')"
            [ngClass]="{'margin-top-40':(quoteForm.get('taxfreelumpsum').errors && quoteForm.get('taxfreelumpsum').touched && 
                            userInputDetail.sliderTaxfreeLumpsumConfig.unselectedByDefault)}">
            <div *ngIf="!multipleTaxfree" class="questions-container col-md-6 clear-all">
            </div>
            <div *ngIf="multipleTaxfree" class="width-47">
              <div class="questions-container clear-all">
                <div class="row mt-5">
                  <app-question [childId]="'taxfreeCashPlaygroundSecond'"
                    (valueChange)='toggleSlider($event,"taxfreeSecond")'
                    [questionConfig]="userInputDetail.radioButtontaxfreeCashOthersConfig" [parent]="quoteForm"
                    [controlName]="'taxfreeRadioButtonSecondary'"
                    (onDisplayMobileTooltipEmitter)="displayTooltipMessage(userInputDetail.radioButtontaxfreeCashOthersConfig)">
                  </app-question>
                </div>
                <div *ngIf="showSecondTaxfreeSlider" class="row mt-5">
                  <app-simple-slider [sliderId]="'taxfreeSlider'"
                    (calculatedValueClickHandler)="oncalculatedValue($event, 'secondary')"
                    [sliderConfig]="userInputDetail.sliderTaxfreeLumpsumConfigSecondary" [parent]="quoteForm"
                    [controlName]="'taxfreelumpsumSecondary'" (onScrollEndHandler)="changeScrollParams($event)"
                    [fundAmount]="(this.pensionArray && this.pensionArray.length > 1) ? this.pensionArray[1].fundValue : 0"
                    (onDisplayMobileTooltipEmitter)="displayTooltipMessage(userInputDetail.sliderTaxfreeLumpsumConfigSecondary)"></app-simple-slider>
                </div>
                <div *ngIf="showSecondTaxfreeInput" class="row">
                  <app-currency *ngIf="source" [parent]="quoteForm"
                    [controllerData]="userInputDetail.secondaryTaxfreeValueConfig"
                    [controlName]="'fundValueTaxfreeSecondary'" [componentName]="'yourOptions'" [source]="'external'"
                    (currencyChangeEventEmitter)="taxfreeChangeHandler($event,'second')"
                    (onDisplayMobileTooltipCurrencyEmitter)="displayTooltipMessage(userInputDetail.secondaryTaxfreeValueConfig)"></app-currency>
                </div>
              </div>
            </div>
            <div class="row add-quote-button  button-center-align-container">
              <!-- padding-top-10 -->
              <!-- [ngClass]="{'btn-multi-taxfree':multipleTaxfree}" -->
              <button *ngIf="loadingFlag" class="btn btn-primary btn-loading mtbr-0-index mar-245 float-right"
                type="button">
                <span class="btn-text">Primary button</span>
                <div class="spinner spinner-white">
                  <div class="spinner-ring" aria-hidden="true"></div>
                  <span class="access">Loading...</span>
                </div>
              </button>
              <div class="button-container">
                <app-content-bottom-nav *ngIf="!loadingFlag" (onNextHandler)="gotoNextPage(target)"
                  [userInputDetail]="userInputDetail['buttonAddCalculationConfig']" [buttonType]="'primarybutton'">
                </app-content-bottom-nav>
              </div>
            </div>
          </ng-container>
          <!-- 5th part done -->
          <div class="col-md-12 clear-all content-section" *ngIf="errormessage && errormessage !== ''">
            <div class="row question-info col-md-12 p-0 margintop-30 warning" [ngClass]="questionInfoClass">
              <!-- -->
              <p class="color-white" id="optionCalculation-error" [innerHTML]="errormessage"></p>
              <!--  You have reached the maximum
                        number of calculations permitted. Please edit a card to either delete it and create a new
                        one, or to change its options.-->
            </div>
          </div>

          <!--   recaptcha block begins-->
          <div class="card-body">
            <re-captcha #captchaRef (resolved)="successResponseReceivedEvent($event)" siteKey="{{reCaptchaSiteKey}}"
              size="invisible"></re-captcha>

          </div>
          <!--   recaptcha block ends-->

        </div>

        <div class="row add-quote-button button-center-align-container"
          *ngIf="selectedProduct && selectedProduct.productCode === 'C'">
          <div *ngIf="!multipleTaxfree" class="row">
            <button *ngIf="loadingFlag" class="btn btn-primary btn-loading mbr-40-index float-right" type="button">
              <span class="btn-text">Primary button</span>
              <div class="spinner spinner-white">
                <div class="spinner-ring" aria-hidden="true"></div>
                <span class="access">Loading...</span>
              </div>
            </button>
            <div class="button-container">
              <app-content-bottom-nav *ngIf="!loadingFlag" (onNextHandler)="gotoNextPage()"
                [userInputDetail]="userInputDetail['buttonAddCalculationConfig']" [buttonType]="'primarybutton'">
              </app-content-bottom-nav>
            </div>
          </div>
        </div>


      </div>
    </form>
  </div>
  <app-modal *ngIf="displayTooltipAlert" [modalConfig]="tooltipModalConfig" (closeModal)="closeTooltipModal()"
    (primaryBtnClick)="alertTooltipPrimaryBtnClick($event)" (secondaryBtnClick)="alertSecondaryBtnClick()"
    [tooltipFlag]="true"></app-modal>
</div>